export const popup = (feature) => {
  const {
  	name,
  	location,
  	description,
  	dateCommenced,
  	images,
  	status,
  	overview,
  	exitStrategies
  } = feature.properties;
  
  const id = feature.id;
  
  const formatDate = (date) => {
  	const toOrdinal = (number) => {
  		let suffixes = ["st", "nd", "rd"]
  		let exceptions = [11, 12, 13]
  		let suffix = 
  		suffixes[(number % 10) - 1] == undefined || exceptions.includes(number % 100) ? "th" : suffixes[(number % 10) - 1];
  		return `${number}${suffix}`;
  	};
  	
  	const times = date.split("-").map((time) => parseInt(time));
  	const dateObject = new Date(...times);
  	
  	const months = [
  		"January",
  		"February",
  		"March",
  		"April",
  		"May",
  		"June",
  		"July",
  		"August",
  		"September",
  		"October",
  		"November",
  		"December"
  	];
  	
  	const day = dateObject.getDate();
  	const month = months[dateObject.getMonth()];
  	const year = dateObject.getFullYear();
  	return `${toOrdinal(day)} ${month} ${year}`;
  }

  const createImage = ({ image, index, category, aspectRatio }) => {
  	const alt = `${category} image ${index + 1}`;
  	
    return `
      <div
        class="
          carousel-item
          aspect-ratio
          aspect-ratio-${aspectRatio} ${index ? "" : "active"}
        "
      >
      	<img
      	  class="aspect-ratio-content rounded-2"
      	  src="${image.medium}"
      	  alt="${alt}"
      	  data-bs-toggle="modal"
      	  data-bs-target="#image-viewer"
      	/>
      </div>
    `;
  }
  
  const createCarousel = ({ images, id, category, aspectRatio }) => `
  	<div id="${id}" class="carousel slide" data-bs-ride="carousel">
  		<div class="carousel-inner">
  			${images.map((image, index) => createImage({ image, index, category, aspectRatio })).join("")}
  		</div>
  		<a class="carousel-control carousel-control-prev" href="#${id}" role="button" data-bs-slide="prev">
  			<span class="carousel-control-prev-icon" aria-hidden="true"></span>
  			<span class="sr-only">Previous</span>
  		</a>
  		<a class="carousel-control carousel-control-next" href="#${id}" role="button" data-bs-slide="next">
  			<span class="carousel-control-next-icon" aria-hidden="true"></span>
  			<span class="sr-only">Next</span>
  		</a>
  	</div>
  `;
  
  let $mainCarousel = createCarousel({
  	images,
  	id: "project-images",
  	category: "Project image",
  	aspectRatio: "1-1"
  });
  
  let $statusCarousel = createCarousel({
  	images: status.media.images,
  	id: "status-images",
  	category: "Status image",
 	aspectRatio: "16-9"
  });

  const formatter = new Intl.NumberFormat("en-US", {
  	style: "currency",
  	currency: "USD",
  	// maximumFractionDigits: 0,
  });
  
  const createStatusVideo = () => {
  	return `
  		<div class="aspect-ratio aspect-ratio-16-9 mb-4 rounded-2 overflow-hidden">
  			<iframe
  				src="https://www.youtube.com/embed/${status.media.video}"
  				width="420"
  				height="315"
  				allowfullscreen
  				class="aspect-ratio-content"
  			></iframe>
  		</div>
  	`;
  }
  
  const numberOfExitStrategies = exitStrategies.length;
  
  const createExitStrategy = (data, strategyNumber) => {
  	const salePrice = `${formatter.format(data.salePrice[0])}${data.salePrice[1] ? " - " + formatter.format(data.salePrice[1]) : ""}`;
  	
  	return `
  		<section class="p-0 col-12">
  			${numberOfExitStrategies > 1 ? "<h4 class='mb-4 py-2 text-center fs-3 fw-bold'>" + "Option " + strategyNumber + "</h4>" : ""}
  			<section class="">
  				<p>${data.description}</p>
  				<table class="table">
  					<tr>
  						<th scope="row" class="me-2">Duration</th>
  						<td class="">${data.duration}</td>
  					</tr>
  					<tr>
  						<th scope="row">Sale Price</th>
  						<td class="">${salePrice}</td>
  					</tr>
  					<tr">
  						<th scope="row" class="mb-2">Estimated Profit</th>
  						<td class="pe-0 pb-0">
  							<table class="table mb-0">
  								<tr>
  									<th scope="row" class="pt-0 ps-0">Total</th>
  									<td class="pt-0">${formatter.format(data.estimatedProfit.total)}</td>
  								</tr>
  								<tr>
  									<th scope="row" class="ps-0">Per Share</th>
  									<td>${formatter.format(data.estimatedProfit.perShare)}</td>
  								</tr>
  								<tr>
  									<th scope="row" class="border-0 ps-0">Investment Return</th>
  									<td class="border-0">${data.estimatedProfit.investmentReturn}%</td>
  								</tr>
  							</table>
  						</td>
  					</tr>
  				</table>
  			</section>
  		</section>
  	`;
  };
  
  const createStatusDescriptionItem = (text) => {
  	return `
  		<li class="list-group-item d-flex">
  			<i class="fa fa-check py-1"></i>
  			<span class="ms-2">${text}</span>
  		</li>
  	`
  };
  
  const $statusDescription = status.description.map(createStatusDescriptionItem).join("");
  
  const $exitStrategies = exitStrategies.map((strategy, strategyNumber) => createExitStrategy(strategy, strategyNumber + 1)).join("");

  const html = `
	<section class="popup m-0 px-0 py-2 w-100 text-secondary">
		<header class="pt-3 col-12">
      		${$mainCarousel}
		</header>
		<section class="summary py-4 col-12">
			<h2 class="mb-4 text-center fs-2 fw-bold">${name}</h2>
			<section class="">
				<div class="my-2 fw-bold">${location}</div>
				<div class="my-2">${description}</div>
				<!-- <div class="d-flex">
					<span class="me-2">Estimated Profit:</span>
					<div>
						<div>${""}</div>
					</div>
				</div> -->
				<div class="d-flex">
					<span class="me-2">Project Commenced:</span>
					<span>${formatDate(overview.dateCommenced)}</span>
				</div>
			</section>
		</section>
		<section class="status py-4 col-12">
			<h2 class="mb-4 text-center fs-2 fw-bold">Status</h2>
			<section class="">
				<section class="mb-4">
					${$statusCarousel}
				</section>
				${status.media.video ? createStatusVideo() : ""}
				<ul class="list-group">
					${$statusDescription}
				</ul>
			</section>
		</section>
		<section class="overview py-4 col-12">
			<h2 class="mb-4 text-center fs-2 fw-bold">Overview</h2>
			<table class="table">
				<tr>
					<th scope="row" class="me-2">Project Commenced</th>
					<td>${formatDate(overview.dateCommenced)}</td>
				</tr>
				<div class="my-2">
					<th scope="row" class="me-2">Purchase Cost (Stage 1)</th>
					<td>${formatter.format(overview.purchaseCost)}</td>
				</tr>
				<tr class="my-2">
					<th scope="row" class="me-2">Share Cost (100 shares)</th>
					<td>${formatter.format(overview.shareCost)}</td>
				</tr>
				<tr>
					<th scope="row" class="me-2">Shares Status</th>
					<td>
						<span class="badge bg-${overview.sharesStatus === "Available" ? "success" : "danger"}">${overview.sharesStatus}</span>
					</td>
				</tr>
			</table>
		</section>
		<section class="exit-strategies py-4 col-12">
			<h2 class="mb-4 text-center fs-2 fw-bold">${numberOfExitStrategies > 1 ? "Exit Strategies" : "Exit Strategy"}</h2>
			<section class="">
				${$exitStrategies}
			</section>
		</section>
	</section>
  `;

  return html;
}